var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_082_finland",
    "data-name": "082 finland",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 14.85,
    cy: 15,
    rx: 14.85,
    ry: 15,
    transform: "translate(0.187 -0.001)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M29.873,18.588H11.739V6.085A15.035,15.035,0,0,0,7.826,7.531V18.588H.127a14.7,14.7,0,0,0,0,3.856h7.7V33.5a15.035,15.035,0,0,0,3.913,1.446v-12.5H29.873a14.7,14.7,0,0,0,0-3.856Z",
    transform: "translate(0 -5.228)",
    fill: "#0052b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi);
export default __webpack_public_path__ + "static/media/FI.48d0492e4f80184958dce76c13e329a3.svg";
export { ForwardRef as ReactComponent };